import { DAP_SANITY_CONFIG } from '@dap/common/consts';
import { createClient, ClientConfig } from '@sanity/client';

const { projectId, dataset, apiVersion, useCdn } = DAP_SANITY_CONFIG;

const config: ClientConfig = {
  projectId,
  apiVersion,
  dataset,
  useCdn,
  ignoreBrowserTokenWarning: true, // Since we are fetching the token from the API, we don't need to ignore the token warning as it's only available to authenticated users
  perspective: 'published', // Since we are using a read token, we need to set the perspective to published to prevent returning draft content
};

export const dapSanityClient = createClient(config);
